import gql from "graphql-tag";

const TimetableProps = gql`
	fragment TimetableProps on Timetable {
		id
		start
		end
		author {
			id
			first_name
			surname
			type {
				id
				name
			}
			designation {
				id
				name
			}
			middle_name
			department {
				id
				name
			}
			image
		}
		plans {
			id
			title
			date
		}
		created_at
	}
`;

const LIST = gql`
	query GetTimetables($id: ID!) {
		GetTimetables(admission: $id) {
			docs {
				...TimetableProps
			}
		}
	}
	${TimetableProps}
`;
const CREATE = gql`
	mutation NewTimetables($model: NewTimetableInput!) {
		StartNewTimetable(input: $model) {
			message
			doc {
				...TimetableProps
			}
		}
	}
	${TimetableProps}
`;

const ADD_NOTE = gql`
	mutation AddNote($id: ID!, $note: TimetablePlan!) {
		AddMoreNoteToTimetable(id: $id, note: $note) {
			message
			doc {
				...TimetableProps
			}
		}
	}
	${TimetableProps}
`;

export { LIST, CREATE, ADD_NOTE };
